const state = {
    error: null,
    // api-publica-docs-y-permisos: catálogo de permisos asignables a una key
    // (`grantable` depende del usuario), con TTL corto y atado al tenant.
    permissionCatalog: {
        data: null,
        tenantId: null,
        expiredAt: null
    }
};

export default state;
